import ListHarvestProcesses from "@/views/organization/projections/query_estimated_harvest/ListHarvestProcesses.vue";
import ShowHarvestProcess from "@/views/organization/projections/query_estimated_harvest/ShowHarvestProcess.vue";
import ShowHarvestProcessEstimatedHarvests from "@/components/views/organization/projections/query_estimated_harvest/show_process/EstimatedHarvests.vue";
import ShowHarvestProcessEstimatedContainers from "@/components/views/organization/projections/query_estimated_harvest/show_process/EstimatedContainers.vue"

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "org",
  role: "projections",
  permission: "query_estimated_harvest"
});

export default [
  {
    path: "/org/:organization_id/projections/query_estimated_harvest/list_harvest_processes",
    name: routeName(""),
    redirect: { name: routeName("list_harvest_processes") }
  },
  {
    path: "/org/:organization_id/projections/query_estimated_harvest/list_harvest_processes",
    name: routeName("list_harvest_processes"),
    component: ListHarvestProcesses,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/projections/query_estimated_harvest/show_harvest_process/:harvest_process_id",
    name: routeName("show_harvest_process"),
    redirect: { name: routeName("show_harvest_process_estimated_harvests") },
    component: ShowHarvestProcess,
    props: true,
    meta: META,
    children: [
      {
        path: "query_estimated_harvests",
        name: routeName("show_harvest_process_estimated_harvests"),
        component: ShowHarvestProcessEstimatedHarvests,
        props: true
      },
      {
        path: "estimated_containers",
        name: routeName("show_harvest_process_estimated_containers"),
        component: ShowHarvestProcessEstimatedContainers,
        props: true
      }
    ]
  }
];
